/**
 * A render crash inside a run summary must never unmount the Brand Bible page (and with it the person's held edit).
 * The summary is secondary information: on an error it is simply not shown, and it is tried again for the next run.
 */
import { Component, type ReactNode } from 'react';

interface Props {
  /** Changes with each run, so a summary that crashed is tried again for the next result. */
  resetKey?: unknown;
  children: ReactNode;
}

export class SummaryBoundary extends Component<Props, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    // The error type only: a summary holds client answers, which never go to a log.
    console.warn('[BB_SUMMARY] run summary failed to render:', error instanceof Error ? error.name : typeof error);
  }

  componentDidUpdate(prev: Props) {
    if (this.state.failed && prev.resetKey !== this.props.resetKey) this.setState({ failed: false });
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
